import { Id } from "@dgs/core";

export const payrollKeys = {
	all: ["payrolls"] as const,
	lists: () => [...payrollKeys.all, "lists"] as const,
	ownLists: () => [...payrollKeys.lists(), "own"] as const,
	details: () => [...payrollKeys.all, "detail"] as const,
	detail: (id: Id) => [...payrollKeys.details(), `${id}`],
};
